import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { getGroupPromotionByGRPID } from "../../../../Api/ApiPromotion";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import {
  AxixTitle,
  ChartContainer,
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import { ISeries } from "../PayBoard/PayHistorySection";
import ReactApexChart from "react-apexcharts";
import DashBoardToggleBtn from "../DashBoardToggleBtn";
import useIsMobile from "../../../../hooks/useIsMobile";
import Loader from "../../../DefaultStyles/Loader";

interface CouponSectionProps extends IndateSectionProps {}

export default function PointSection({
  filter,
  setFilter,
}: CouponSectionProps) {
  const isMobile = useIsMobile();

  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [aliasList, setAliasList] = useState<string[]>([]);
  const [date, setDate] = useState<string[]>([]);

  const { response, loading } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? filter?.isAccum
          ? `dash/gap?type=point&startdate=${dayjs(filter.startDate)
              .add(1, "day")
              ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
              .add(1, "day")
              ?.format("YYYY-MM-DD")}`
          : `dash/promotionReg?type=point&subtype=grouppromotion&startdate=${dayjs(
              filter.startDate
            )
              .add(1, "day")
              ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
              .add(1, "day")
              ?.format("YYYY-MM-DD")}`
        : undefined,
  });

  const getDatesStartToLast = (startDate: string, lastDate: string) => {
    let regex = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);

    if (!(regex.test(startDate) && regex.test(lastDate))) return [];

    let result: string[] = [];

    let curDate = new Date(startDate);

    while (curDate <= new Date(lastDate)) {
      result.push(curDate.toISOString().split("T")[0]);
      curDate.setDate(curDate.getDate() + 1);
    }

    return result;
  };

  useEffect(() => {
    let series: any[] = [];

    let aliasList: string[] = [];

    if (response?.status === 200) {
      if (filter?.isAccum) {
        // 포인트별
        let list = [];

        if (response?.data?.length > 0) {
          const filteredData = response?.data?.filter((data: any) => {
            return data.total !== 0;
          });

          for (let i = 0; i < filteredData.length; i++) {
            const element = filteredData[i];

            const alias =
              getGroupPromotionByGRPID(Number(element.detail))?.GRP_ALIAS ??
              "이름";
            const promId =
              String(
                getGroupPromotionByGRPID(Number(element.detail))?.PROM_ID
              ) ?? "";

            const promIdArray = promId.split(",");

            if (element?.total > 0) {
              aliasList.push(alias);

              list.push(
                Math.ceil((element?.total ?? 0) / (promIdArray?.length ?? 1))
              );
            }
          }

          setSeries([
            {
              name: "등록 인원",
              data: list,
            },
          ]);

          setAliasList(aliasList);
        }
      } else {
        // 일별
        console.log("✅", response?.data);

        const arr = Object.entries(response?.data);

        for (let i = 0; i < arr.length; i++) {
          const element = arr[i] as [string, []];

          const key =
            getGroupPromotionByGRPID(+element[0])?.GRP_ALIAS ?? "이름";

          series.push({
            data: element[1],
            name: key,
          });

          console.log("✅✅", element);
        }

        setDate(getDatesStartToLast(filter.startDate, filter.endDate));
        setSeries(series);
      }
    }
  }, [response, filter]);

  console.log("❤️", filter);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>포인트 등록 현황</DashBoardSectionTitle>

        <DashBoardToggleBtn
          btnTextArray={["일별", "포인트별"]}
          filter={filter}
          setFilter={setFilter}
          clickEvent={() =>
            setSeries([
              {
                name: "",
                data: [0, 0, 0, 0],
              },
            ])
          }
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate isMobile={isMobile}>
          조회 기간 : {filter.startDate} ~ {filter.endDate}
        </DashBoardViewDate>

        {loading ? (
          <ChartContainer>
            <Loader />
          </ChartContainer>
        ) : (
          <ChartContainer>
            <AxixTitle>명</AxixTitle>

            <ReactApexChart
              type="bar"
              height={300}
              series={series}
              options={{
                chart: {
                  type: "bar",
                  stacked: filter.isAccum ? false : true,
                  toolbar: {
                    show: false,
                  },
                  zoom: {
                    enabled: false,
                  },
                },
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      legend: {
                        position: "bottom",
                        offsetX: -10,
                        offsetY: 0,
                      },
                    },
                  },
                ],
                plotOptions: {
                  bar: {
                    horizontal: false,
                    dataLabels: {
                      position: "top",
                    },
                    distributed: filter.isAccum ? true : false,
                  },
                },
                dataLabels: {
                  enabled: true,
                  formatter: (value, { seriesIndex, dataPointIndex, w }) => {
                    const series = w.globals.series as number[][];

                    let step = 0;

                    for (let i = 0; i < series.length; i++) {
                      const element = series[i];

                      if (element[dataPointIndex] !== 0) {
                        step += 1;
                      }
                    }

                    if (
                      value !== 0 &&
                      (seriesIndex === step - 1 || seriesIndex === step)
                    ) {
                      return `${getThousandComma(
                        w.globals.stackedSeriesTotals[dataPointIndex]
                      )}`;
                    } else {
                      return "";
                    }
                  },
                  offsetY: -20,
                  style: {
                    fontSize: "12px",
                    colors: ["#304758"],
                  },
                },
                xaxis: {
                  labels: {
                    formatter: (value) => {
                      if (filter.isAccum) {
                        return value;
                      } else {
                        return dayjs(value).format("M/DD (dd)");
                      }
                    },
                  },
                  categories: filter.isAccum ? aliasList : date,
                  position: "left",
                },
                yaxis: {
                  labels: {
                    formatter: (value) => {
                      return getThousandComma(value);
                    },
                  },
                },
                legend: {
                  position: "bottom",
                  offsetY: 7,
                  fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                  markers: {
                    width: 10,
                    height: 10,
                    offsetX: -4,
                    radius: 10,
                  },
                  fontSize: "13px",
                  fontWeight: 500,
                  itemMargin: {
                    horizontal: 16,
                  },
                },
                fill: {
                  opacity: 1,
                },
                tooltip: {
                  x: {
                    formatter: (value) => {
                      if (filter.isAccum) {
                        return `${value}`;
                      } else {
                        return dayjs(value).format("M/DD (dd)");
                      }
                    },
                  },
                  y: {
                    formatter: (value) => getThousandComma(value ?? 0) + "명",
                  },
                },
              }}
            />

            <AxixTitle isX>{filter.isAccum ? "포인트명" : "날짜"}</AxixTitle>
          </ChartContainer>
        )}
      </LineBox>
    </>
  );
}
